import { forwardRef } from 'react';
import { vars } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { Info } from '@phosphor-icons/react';
import { useTranslation } from '@eti/providers';
import { jsx as _jsx } from "react/jsx-runtime";
const getInfoIconButtonStyles = size => css`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: ${size}px;
  justify-content: center;
  width: ${size}px;
`;
const infoIconFocusStyles = css`
  outline: none;
  position: relative;

  &::after {
    border: 2px solid ${vars.colors.focusRing};
    border-radius: 50%;
    content: '';
    height: calc(100% + 4px);
    left: -2px;
    opacity: 0;
    position: absolute;
    top: -2px;
    transition: opacity 0.2s ease-in-out;
    width: calc(100% + 4px);
  }

  &:focus-visible::after {
    opacity: 1;
  }
`;
const InformationIconButton = /*#__PURE__*/forwardRef(function InformationIconButton({
  className,
  size = 20,
  ...rest
}, ref) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx("button", {
    "aria-label": t('ScreenReader.InformationIconButton.AriaLabel.Text'),
    ...rest,
    className: cx(resetButtonStyle, getInfoIconButtonStyles(size), infoIconFocusStyles, className),
    ref: ref,
    type: "button",
    children: /*#__PURE__*/_jsx(Info, {
      color: vars.colors.signal.information.foreground,
      role: "presentation",
      size: size,
      weight: "fill"
    })
  });
});
export default InformationIconButton;
//# sourceMappingURL=InformationIconButton.js.map